import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "@/lib/utils";
import { Button, Icon } from "@bookips/sds";
const HomeCarouselButton = (param)=>{
    let { canScrollPrev , canScrollNext , scrollPrev , scrollNext  } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex items-center gap-2 ",
        children: [
            /*#__PURE__*/ _jsx(Button, {
                variant: "stroke",
                color: "secondary",
                size: "md",
                disabled: !canScrollPrev,
                className: cn("p-2.5", "max-lg:hidden"),
                onClick: scrollPrev,
                children: /*#__PURE__*/ _jsx(Icon.ArrowLeft_2px, {
                    size: "md",
                    className: cn("w-5 h-5", canScrollPrev ? "text-primary" : "text-gray-200")
                })
            }),
            /*#__PURE__*/ _jsx(Button, {
                variant: "stroke",
                color: "secondary",
                size: "md",
                disabled: !canScrollNext,
                className: cn("p-2.5", "max-lg:hidden"),
                onClick: scrollNext,
                children: /*#__PURE__*/ _jsx(Icon.ArrowRight_2px, {
                    size: "md",
                    className: cn("w-5 h-5", canScrollNext ? "text-primary" : "text-gray-200")
                })
            })
        ]
    });
};
export default HomeCarouselButton;
